import React from "react";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { get, size } from "lodash";
import { capitalCase } from "change-case";

import IconTableHeader from "components/IconTableHeader";
import ApprovalCard from "./ApprovalCard";
import IconTable, { type IconTableColumn } from "components/IconTable";
import { kvPairs } from "utils/typeUtils";

interface MetadataItem {
  name: string;
  value: unknown;
}

interface Approval {
  metadataItems?: MetadataItem[];
}

// PropTypes were `client: object, approval: object`; tightened to actual usage.
// `client` comes from withApollo (WithApolloClient); `approval` is parent-passed.
interface OwnProps {
  approval?: Approval;
}

type Props = WithApolloClient<OwnProps>;

const UnfreezeRequestApproval = (props: Props) => {
  const metadataItems = get(props.approval, "metadataItems", []);
  const metadataObject = metadataItems.reduce<Record<string, unknown>>(
    (acc, item) => {
      acc[item.name] = item.value;
      return acc;
    },
    {}
  );
  const tableMetadata: Array<IconTableColumn<{ key: string; value: unknown }>> =
    [
      {
        key: "key",
        label: "Key",
        format: (value) => {
          return capitalCase(value as string);
        },
      },
      {
        key: "value",
        label: "Value",
        format: (v) => {
          return `${String(v)}`;
        },
      },
    ];

  return (
    <>
      <ApprovalCard>
        <IconTableHeader tableCount={size(metadataObject)} tableHeader="Info" />
        <IconTable columns={tableMetadata} data={kvPairs(metadataObject)} />
      </ApprovalCard>
    </>
  );
};

export default withApollo<Props>(UnfreezeRequestApproval);
